import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "table table-hover align-middle mt-4" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "border-dark border-bottom" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  colspan: 4,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_BaseEditButton = _resolveComponent("BaseEditButton")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('productFilters'),
          "help-text": _ctx.$t('descriptionProductFiltersOverview'),
          mb: 3,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, _createSlots({ _: 2 }, [
          (_ctx.AbilityContext.isAuthorizedForFeature('NAMED_PRODUCT_FILTER'))
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_router_link, {
                      to: {name: 'new-product-filter'},
                      class: "btn btn-hover icon-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "help-text", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
              _createElementVNode("th", null, _toDisplayString(`#${_ctx.$t('products')}`), 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.pageUI.isReady())
              ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                  key: 0,
                  "n-cols": 4
                }))
              : _createCommentVNode("", true),
            (_ctx.pageUI.isReady() && !_ctx.productFilters.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('noContentFound')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.pageUI.isReady())
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.productFilters, (productFilter) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: productFilter.code
                  }, [
                    _createElementVNode("td", null, _toDisplayString(productFilter.name ?? productFilter.code), 1),
                    _createElementVNode("td", null, _toDisplayString(productFilter.precalculated_product_count), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_BaseEditButton, {
                          targetRoute: {name: 'edit-product-filter', params: {code: productFilter.code}}
                        }, null, 8, ["targetRoute"]),
                        (!productFilter.is_predefined)
                          ? (_openBlock(), _createBlock(_component_BaseDeleteButton, {
                              key: 0,
                              deleteData: () => _ctx.deleteItemWithKey(productFilter.code),
                              itemKey: productFilter.code,
                              pageUI: _ctx.pageUI,
                              class: "ms-2"
                            }, null, 8, ["deleteData", "itemKey", "pageUI"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}